import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box } from '@mui/material';
import { SketchPicker } from 'react-color';

import { DEFAULT_COLOR } from '@/constants';
import { CloseIcon } from '@/components';

import { HeaderStyled, BodyStyled } from './styles';

const ColorPickerPopover = (props) => {
  const { color, onChange, onClose } = props;
  const selected = color || DEFAULT_COLOR;

  const handleColorChange = (color) => {
    onChange(color.hex);
  };

  return (
    <Box sx={{ padding: '20px 15px 5px', borderRadius: '10px', boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.3)', width: '330px' }}>
      <HeaderStyled>
        <FormattedMessage id="app.editor.modal.selectColor" defaultMessage="Select color" />
        <Box sx={{ display: 'flex', cursor: 'pointer' }} onClick={onClose}>
          <CloseIcon />
        </Box>
      </HeaderStyled>

      <BodyStyled>
        <SketchPicker width="100%" color={selected} onChangeComplete={handleColorChange} />
      </BodyStyled>
    </Box>
  );
};

export default ColorPickerPopover;
